<template>
  <div class="tab-pane fade" id="nav-transactions" role="tabpanel" aria-label="nav-transactions-tab">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12">
          <!-- Transactions Tab -->
          <!-- View and Search Transactions header -->
          <div class="container-fluid">
            <div id="vt_accordion" class="accordion border border-light rounded">
              <div class="card mb-0">
                <!-- <div class="card-header collapsed col-sm-12" data-toggle="collapse" href="#collapseOne"> -->
                <div class="card-header collapsed col-sm-12" data-toggle="collapse">
                  <div class="row">
                    <div class="col-sm-4">
                      <p>View Transactions</p>
                    </div>
                    <div class="col-sm-4">
                      <div class="search_75">
                        <form class="input-group md-form form-sm">
                          <input class="form-control form-control-sm search" name="search" placeholder="Search"
                            autocomplete="off" type="text" v-model="ledgerSearch" />
                          <div class="input-group-btn">
                            <a href="#" role="button">
                              <i class="fa fa-search active" aria-hidden="true"></i>
                            </a>
                          </div>
                        </form>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-4 mobile-space-t">
                      <button type="button" data-toggle="collapse" data-target=".sh_search"
                        class="more btn btn-hc-nb float-right"></button>
                    </div>
                  </div>
                  <div class="sh_search collapse show mt-3">
                    <div class="row">
                      <div class="col-12 col-sm-6">
                        <div class="row">
                          <div class="col-sm-6">
                            <a @click="last30Days" role="button" class="btn btn-hc-outline btn-block no-pad">Last 30
                              days</a>
                          </div>
                          <div class="col-sm-6">
                            <a @click="last6Months" role="button" class="btn btn-hc-outline btn-block no-pad">Last 6
                              months</a>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-6 mt-2">
                            <a @click="last12Months" role="button" class="btn btn-hc-outline btn-block no-pad">Last 12
                              months</a>
                          </div>
                          <div class="col-sm-6 mt-2">
                            <a @click="clearFilter" role="button" class="btn btn-hc-outline btn-block no-pad">Clear
                              filters</a>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-sm-6">
                        <div class="row">
                          <div class="col-sm-12">
                            <el-date-picker v-model="startDate" format="dd.MM.yyyy" type="date"
                              placeholder="Select a start date"></el-date-picker>
                          </div>
                          <div class="col-sm-12">
                            <el-date-picker class="my-2" v-model="endDate" format="dd.MM.yyyy" type="date"
                              placeholder="Select an end date"></el-date-picker>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="table-div mt-3 pl-3 pr-3" v-if="ledger">
            <b-table id="db_transactions_table" class="table-scroll tbl-sml" striped :items="filteredTransactions"
              :fields="ledgerFields" :tbody-tr-class="futureDated">
              <template slot="Created" slot-scope="data">{{ data.item.Created | formatDate }}</template>
              <template slot="Description" slot-scope="data">
                <a v-if="data.item.Category == 'Sales'" @click="viewInvoice(data.item.DocumentUri)"
                  id="View" style="cursor: pointer">{{ (data.item.Description) }}</a>

                <span v-if="data.item.Category == 'Bank'">{{ (data.item.Description) }}</span>
                <span v-if="data.item.Memo" class="d-inline">
                  <span v-b-popover.click.hover.right="data.item.Memo" title="Notes" class="pointer">
                    <i class="fas fa-sticky-note ml-2"></i>
                    <i class="fas fa-pencil-alt"></i>
                  </span>
                </span>
              </template>
              <template slot="Debit" slot-scope="data">{{ data.item.Debit | currency }}</template>
              <template slot="Credit" slot-scope="data">{{ data.item.Credit | currency }}</template>
              <!-- <template slot="Balance" slot-scope="data">
                                {{data.item.Balance | currency}}
              </template>-->
              <template slot="Balance" slot-scope="data">
                <div v-if="data.item.Balance < 0" class="text-danger">{{ data.item.Balance | currency }}</div>
                <div v-else>{{ data.item.Balance | currency }}</div>
              </template>
              <template slot="action" slot-scope="data">
                <i v-if="allocationMethod === 'Manual'" class="fas fa-info pointer fa-lg"
                  @click="openModal(data.item.TransactionId)"></i>
                <a v-if="data.item.IsReversible == true && data.item.PreventReversal !== true" href="#"
                  data-toggle="modal" data-target="#ReverseTransaction" id="Reverse" class="ml-3"
                  @click="rowClicked(data.item)">
                  <img src="@/assets/img/reverse_icon.png" />
                </a>

              </template>
            </b-table>
          </div>
          <!-- Transactions table end -->
        </div>
      </div>
    </div>

    <!--Allocations Modal-->
    <template>
      <div class="tab-pane fade" id="nav-transactions" role="tabpanel">
        <allocations-table ref="allocationsTable" :transactionId="selectedTransactionId" />
      </div>
    </template>
  </div>
</template>

<script>
import moment from 'moment';
import _filters from '@/mixins/filters.js';
import AllocationsTable from "../../modals/Allocations.vue"


export default {
  components: {
    AllocationsTable
  },

  mixins: [_filters],
  data() {
    return {
      startDate: "",
      endDate: "",
      ledgerSearch: "",
      ledgerFields: {
        Created: {
          label: "Date",
          sortable: true,
          class: "text-center fwfont col-2"
        },
        Description: {
          label: "Description",
          class: "text-left fwfont col-2"
        },
        Debit: {
          label: "Debit",
          class: "text-center fwfont col-2"
        },
        Credit: {
          label: "Credit",
          class: "text-center fwfont col-2"
        },
        Balance: {
          label: "Balance",
          class: "text-right fwfont col-2"
        },
        action: {
          label: "Action",
          class: "text-center col-2"
        }
      },
      selectedTransactionId: 0,
    };
  },
  methods: {
    last30Days: function () {
      this.endDate = new Date();
      this.startDate = new Date().setTime(
        new Date().getTime() - 3600 * 1000 * 24 * 30
      );
    },
    last6Months: function () {
      this.endDate = new Date();
      this.startDate = new Date().setTime(
        new Date().getTime() - 3600 * 1000 * 24 * 180
      );
    },
    last12Months: function () {
      this.endDate = new Date();
      this.startDate = new Date().setTime(
        new Date().getTime() - 3600 * 1000 * 24 * 365
      );
    },
    clearFilter: function () {
      this.startDate = null;
      this.endDate = null;
    },
    rowClicked(item) {
      this.$store.commit("updateReverseTransaction", item);
    },
    futureDated(item) {
      if (!item) return;
      if (moment(item.Created).isSameOrAfter(moment().format()))
        return "font-italic text-muted";
    },

    openModal(transactionId) {
      this.selectedTransactionId = transactionId;
      this.$refs.allocationsTable.$refs.modal.show();
    },

    isHoneycombUrl(documentUri) {
      try {
        const hostname = new URL(documentUri).hostname;
        return hostname === this.$config.honeycomb.billbotstatements.domain ||
          hostname.endsWith('.redbearapp.io');
      } catch (e) {
        return false;
      }
    },

    parseHoneycombUrl(documentUri) {
      const urlParts = documentUri.split('/');
      return {
        documentType: urlParts[urlParts.length - 3], // 'statements' or 'invoices'
        documentId: urlParts[urlParts.length - 2],
      };
    },

    viewInvoice(documentUri) {
      if (!this.isHoneycombUrl(documentUri)) {
        window.open(documentUri, '_blank');
        return;
      }

      const { documentType, documentId } = this.parseHoneycombUrl(documentUri);

      this.$http
        .get(
          "https://" +
          this.$config.honeycomb.billbotstatements.domain +
          "/api/v1/" +
          documentType + "/" +
          documentId +
          "/uri",
          { withCredentials: true }
        )
        .then((response) => {
          const finalUrl = response.data.url;
          window.open(finalUrl, "_blank");
        })
        .catch((error) => {
          if (error.response) {
            this.$snotify.error(
              `Error viewing invoice: ${(error.response.data && error.response.data.UserDescription) || error.response.statusText}`,
              {
                timeout: 0,
                closeOnClick: true,
              }
            );
          } else if (error.request) {
            this.$snotify.error(`No response received.`, {
              timeout: 0,
              closeOnClick: true,
            });
          } else {
            this.$snotify.error(`${error.message}`, {
              timeout: 0,
              closeOnClick: true,
            });
          }
        });
    },

  },
  computed: {
    ledger() {
      return this.$store.state.finances.ledger;
    },
    account() {
      return this.$store.state.customers.account;
    },
    allocationMethod() {
      return this.account ? this.account.AllocationMethod : null;
    },
    filteredTransactions() {
      return this.dateFilter.filter(transaction => {
        return transaction.Description.match(
          new RegExp(this.ledgerSearch, "i")
        );
      });
    },
    dateFilter: function () {
      if (!this.startDate || !this.endDate) {
        return this.ledger;
      }
      var that = this;
      return this.$_.filter(this.ledger, function (transaction) {
        return (
          moment(transaction.Created).isSameOrAfter(that.startDate) &&
          moment(transaction.Created).isSameOrBefore(that.endDate)
        );
      });
    }
  }
};
</script>
